// @ts-check
import api from 'utils/api';

const actions = {
  fetchNetwork() {
    return api.get('/agent_portal/api/providers/network').then(response => response.data);
  },

  createHotlisting(providerId) {
    return api.postWithoutDefaultRejectionHandling('/agent_portal/api/providers/hotlistings', {
      hotlisted_provider_id: providerId,
    });
  },

  removeHotlisting(listingId) {
    return api.delete(`/agent_portal/api/providers/hotlistings/${listingId}`);
  },

  createWhitelisting(providerId) {
    return api.postWithoutDefaultRejectionHandling('/agent_portal/api/providers/whitelistings', {
      whitelisted_provider_id: providerId,
    });
  },

  removeWhitelisting(listingId) {
    return api.delete(`/agent_portal/api/providers/whitelistings/${listingId}`);
  },

  createBlacklisting(providerId) {
    return api.postWithoutDefaultRejectionHandling('/agent_portal/api/providers/blacklistings', {
      blacklisted_provider_id: providerId,
    });
  },

  removeBlacklisting(listingId) {
    return api.delete(`/agent_portal/api/providers/blacklistings/${listingId}`);
  },
};

export default actions;
